import { render, staticRenderFns } from "./selected-items-display.vue?vue&type=template&id=5d4db9f1&scoped=true&"
import script from "./selected-items-display.vue?vue&type=script&lang=js&"
export * from "./selected-items-display.vue?vue&type=script&lang=js&"
import style0 from "./selected-items-display.vue?vue&type=style&index=0&id=5d4db9f1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4db9f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4db9f1')) {
      api.createRecord('5d4db9f1', component.options)
    } else {
      api.reload('5d4db9f1', component.options)
    }
    module.hot.accept("./selected-items-display.vue?vue&type=template&id=5d4db9f1&scoped=true&", function () {
      api.rerender('5d4db9f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/selected-items-display/selected-items-display.vue"
export default component.exports